import type { SiteCategory } from './getCategories'

/** Üst menü: cat_sort > 0, küçükten büyüğe */
export function sortHeaderCategories(categories: SiteCategory[]): SiteCategory[] {
  return [...categories]
    .filter((c) => (c.cat_sort ?? 0) > 0)
    .sort((a, b) => (a.cat_sort ?? 0) - (b.cat_sort ?? 0) || a.id - b.id)
}

/** Alt şerit: strip_sort > 0, küçükten büyüğe */
export function sortStripCategories(categories: SiteCategory[]): SiteCategory[] {
  return [...categories]
    .filter((c) => (c.strip_sort ?? 0) > 0)
    .sort((a, b) => (a.strip_sort ?? 0) - (b.strip_sort ?? 0) || a.id - b.id)
}

/**
 * Alt şerit kategorileri — üst menüdeki (cat_sort>0) kayıtlar varsayılan olarak hariç.
 * İstisna: hem üst menü hem alt şerit istenmişse strip_sort ≠ cat_sort (bilinçli çift yerleşim).
 */
export function resolveStripCategories(
  categories: SiteCategory[],
  headerCategories: SiteCategory[] = [],
): SiteCategory[] {
  const headerById = new Map(headerCategories.map((c) => [c.id, c]))

  return sortStripCategories(categories).filter((c) => {
    const inHeader = headerById.get(c.id)
    if (!inHeader) return true
    const headerSort = inHeader.cat_sort ?? 0
    const stripSort = c.strip_sort ?? 0
    return headerSort <= 0 || stripSort !== headerSort
  })
}

/** Footer / menü: aktif kategoriler cat_sort küçükten büyüğe */
export function sortMenuCategories(categories: SiteCategory[]): SiteCategory[] {
  return [...categories].sort(
    (a, b) => (a.cat_sort ?? 0) - (b.cat_sort ?? 0) || a.id - b.id,
  )
}
